import { useState } from "react";
import { getUserInitials, getInitialsFromFullname } from "@/shared/utils/user.utils";

type AvatarProps = {
  avatar: string | { url: string } | null | undefined
  fullname?: string
  firstName?: string
  lastName?: string
  initials?: string
  className?: string
  userType?: string
};

export const Avatar = ({
  avatar,
  fullname,
  firstName,
  lastName,
  initials,
  className,
  userType,
}: AvatarProps) => {
  const [imageError, setImageError] = useState(false);
  const computedInitials = initials
    || (fullname ? getInitialsFromFullname(fullname) : "")
    || getUserInitials(firstName, lastName);

  const defaultClassName = "w-10 h-10 rounded-full flex-none";
  const finalClassName = className || defaultClassName;

  const hasValidAvatar = avatar && !imageError;

  const isElected = userType?.toLowerCase() === "élu";
  const initialsColorClass = isElected
    ? "text-orange-800 dark:text-orange-300"
    : "text-primary";

  return (
    hasValidAvatar
      ? (
        <img
          className={`${finalClassName} object-cover`}
          src={typeof avatar === "string" ? avatar : avatar?.url}
          alt="user photo"
          onError={() => setImageError(true)}
        />
      )
      : (
        <div className={`${finalClassName} flex items-center justify-center text-lg font-medium shadow-none border-2 border-gray-200 bg-gray-200 dark:border-gray-700 dark:bg-gray-700 ${initialsColorClass}`}>
          {computedInitials}
        </div>
      )
  );
};
